export default "__VITE_ASSET__724b092f__"